(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/betslip/assets/javascripts/views/rows-view.js') >= 0) return;  svs.modules.push('/components/tipsen/betslip/assets/javascripts/views/rows-view.js');
"use strict";

const {
  ReactIcon
} = svs.ui;
const {
  RowsDisplay
} = svs.components.tipsen.betslip.views.parts;
const {
  BaseView
} = svs.components.tipsen.betslip.views;
const RowsView = _ref => {
  let {
    icon,
    children,
    isReduced,
    DisplayComponent = RowsDisplay
  } = _ref;
  return React.createElement(BaseView, null, React.createElement("div", {
    className: "betslip-type"
  }, React.createElement(ReactIcon, {
    color: "white",
    icon: icon
  }), children), React.createElement(DisplayComponent, {
    isReduced: isReduced
  }));
};
setGlobal('svs.components.tipsen.betslip.views.RowsView', RowsView);

 })(window);